import { Page } from '../../pay/models/page.model';
export interface Notifications {
  notifications: Page<Notification>;
  unreadMessagesCount: number;
  lastReadAt: Date
}

export interface Notification {
  notificationId: string;
  status: NotificationStatus;
  iconType: IconType;
  title: string;
  content: string;
  cta?: string;
  ctaAction?: string;
  biller: string[];
  createdAt: Date;
}

export enum NotificationStatus {
  READ = 'READ',
  UNREAD = 'UNREAD',
  REMOVED = 'REMOVED',
}

export enum IconType {
  BILLER = 'BILLER',
  COUPON = 'COUPON',
  OCR = 'OCR',
  OTHER = 'OTHER',
}
